import { Routes } from '@angular/router';
import { Login } from './login/login';
import { tenantGuard } from './guards/tenant.guard';
import { rootGuard } from './guards/root.guard';

export const appRoutes: Routes = [
  // --- Mobile first-launch onboarding (native only) ---------------------------
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./pages/onboarding/onboarding').then(m => m.OnboardingPage)
  },

  // --- Authenticated feature area ---------------------------------------------
  // tenantGuard is a no-op on web; on native it redirects to /onboarding
  // if the server has not been configured yet.
  {
    path: 'ops',
    canActivate: [tenantGuard],
    loadChildren: () =>
      import('./operations/operations-route').then(m => m.operationRoutes)
  },

  // --- Mobile login (no marketId in URL) --------------------------------------
  {
    path: 'login',
    canActivate: [tenantGuard],
    component: Login
  },

  // --- Multi-profile switcher (native only) -----------------------------------
  {
    path: 'switch-profile',
    loadComponent: () =>
      import('./pages/switch-profile/switch-profile').then(m => m.SwitchProfilePage)
  },

  // --- Legacy web routes � kept for backwards-compatibility -------------------
  { path: ':marketId', component: Login },
  { path: 'login/:marketId', component: Login },

  // --- Default ----------------------------------------------------------------
  // On native, resolves to the last screen the user was on (if still logged in and
  // configured) instead of always bouncing to onboarding � see rootGuard.
  { path: '', pathMatch: 'full', canActivate: [rootGuard], children: [] }
];
